const TOKEN_KEY_NAME = "session_token"
const EMAIL_KEY_NAME = "session_key"
const ID_KEY_NAME = "session_user_id"
const OAUTH_ID_TOKEN_KEY_NAME = "oauth_id_token"
const MFA_CLIENT_ID = "client_id"

export interface IUserSessionToken {
  userSession: {
    id: string,
    apiToken: string
  }
}

function generateSecureToken(length = 16) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  const array = new Uint8Array(length)
  window.crypto.getRandomValues(array)
  return [...array].map(x => chars[x % chars.length]).join("")
}

export const loadSession = (): IUserSessionToken | Partial<IUserSessionToken> => {
  try {
    const session = getSession()
    if (!session.token || !session.userId) {
      return {}
    }
    return {
      userSession: {
        id: session.userId,
        apiToken: session.token
      }
    }
  } catch (err) {
    console.error("there was an issue with the session", err)
    return {}
  }
}

export const setOAuthIdToken = (token: string) => {
  setItem(OAUTH_ID_TOKEN_KEY_NAME, token)
}

export const setSession = (token: string, id: string, email: string): void => {
  setItem(TOKEN_KEY_NAME, token)
  setItem(EMAIL_KEY_NAME, email)
  setItem(ID_KEY_NAME, id)
  if (getItem(MFA_CLIENT_ID) == null) {
    setItem(MFA_CLIENT_ID, generateSecureToken(32))
  }
}

export const getSession = () => {
  if (getItem(MFA_CLIENT_ID) == null) {
    setItem(MFA_CLIENT_ID, generateSecureToken(32))
  }
  return {
    token: getItem(TOKEN_KEY_NAME),
    email: getItem(EMAIL_KEY_NAME),
    userId: getItem(ID_KEY_NAME),
    oauthIdToken: getItem(OAUTH_ID_TOKEN_KEY_NAME),
    clientId: getItem(MFA_CLIENT_ID)
  }
}

export const getToken = (): string => {
  return getItem(TOKEN_KEY_NAME)
}

export const getApiToken = (): string => {
  return localStorage.getItem(TOKEN_KEY_NAME)
}

export const clearSession = (): void => {
  localStorage.removeItem(TOKEN_KEY_NAME)
  localStorage.removeItem(EMAIL_KEY_NAME)
  localStorage.removeItem(ID_KEY_NAME)
  localStorage.removeItem(OAUTH_ID_TOKEN_KEY_NAME)
  // NOTE: DO NOT CLEAR THE CLIENT ID HERE
}

const setItem = (key: string, value: string) => localStorage.setItem(key, value)
const getItem = (key: string) => localStorage.getItem(key)

